module.exports = __webpack_public_path__ + "s13.no1.c01c26da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s13.no1.jpg
// module id = IaFw
// module chunks = 0